import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Text from "../../../../common/components/base/text";
import SearchBar from "../../../../common/components/base/search/Search";
import RadioGroup from "@mui/material/RadioGroup";
import { FormControlLabel } from "@mui/material";
import CheckRadio from "../../../../common/components/base/checkradio";
import FormGroup from "@mui/material/FormGroup";
import Checkbox from "../../../../common/components/base/checkbox";
import { cardStatementActions } from "../../slice";

const filterTopics = [
    {
        name: "Card Number",
        id: "cardNumber"
    },
    {
        name: "Card Holder",
        id: "cardHolder"
    },
    {
        name: "ID/Passport Number",
        id: "idNumber"
    },
    {
        name: "Card Expiry Date",
        id: "cardExpiry"
    },
    {
        name: "Reference Number",
        id: "cardReference"
    },
    {
      name: "Sequence Number",
      id: "cardSequence"
  }
]

export default function CardStatementFilters({ onSubmit }) {
    const filter = useSelector(state => state.cardStatement.cards.filter);
    const dispatch = useDispatch();

    const handleTopicChange = (event) => {
        const { value, checked } = event.target;
        if (checked) {
            dispatch(cardStatementActions.cardFilterChanged({ searchField: value }));
        }
    }

    const handleExcludeChange = (event) => {
        const { name, checked } = event.target;
        dispatch(cardStatementActions.cardFilterChanged({ [name]: checked }))
    }

    const handleChange = (event) => {
        const { name, value } = event.target;
        dispatch(cardStatementActions.cardFilterChanged({ [name]: value }))
    }

    return (
        <Box>
            <Text light mt={8}>
                FIND
            </Text>
            <Box sx={{ mt: 1 }}>
                <SearchBar
                    onSubmit={onSubmit}
                    onChange={handleChange}
                    name="searchString" value={filter.query}
                    placeholder="Enter your search here" />
                <Box sx={{ pt: 1 }}>
                    <Text light>(LEAVE BLANK TO SHOW ALL)</Text>
                </Box>
                <hr style={{ borderTop: "1px solid rgba(0,0,0,.1)" }} />
                <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
                    <Box>
                        <Text light>FILTER BY TOPIC</Text>
                        <RadioGroup
                            row
                            onChange={handleTopicChange}
                            name="searchField"
                        >
                            {
                                filterTopics.map((topic) => (
                                    <FormControlLabel
                                        key={topic.id + '-filter-topic'}
                                        value={topic.id}
                                        control={<CheckRadio color="secondary"
                                            checked={filter?.searchField === topic.id} />}
                                        label={<Text>{topic.name}</Text>}
                                    />
                                ))
                            }
                        </RadioGroup>
                    </Box>
                    <Box>
                        <Text light>EXCLUDE</Text>
                        <FormGroup row>
                            <FormControlLabel
                                name="excludeExpired"
                                onChange={handleExcludeChange}
                                control={<Checkbox color="secondary"
                                    size="small"
                                    checked={Boolean(filter.excludeExpired)} />}
                                label={<Text>Expired Cards</Text>}
                            />
                            <FormControlLabel
                                name="excludeStopped"
                                onChange={handleExcludeChange}
                                control={<Checkbox color="secondary"
                                    size="small"
                                    checked={Boolean(filter.excludeStopped)} />}
                                label={<Text>Stopped Cards</Text>} />
                        </FormGroup>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}
